/** User discount mode (`billing_type`). */
export const BILLING_TYPE_OPTIONS = [
  { value: 0, text: 'Для новых SMS' },
  { value: 1, text: 'Для отправленных и новых SMS' },
] as const;

export function billingTypeLabel(value: number | null | undefined): string {
  if (value == null) return '—';
  const opt = BILLING_TYPE_OPTIONS.find((o) => o.value === value);
  return opt?.text ?? String(value);
}
